import { useQuery } from '@tanstack/react-query';
import { GET, GET_BREAKDOWN_SUB_OPTIONS, GET_CHANNEL_BUYS, GET_MOBILE_BRANDS } from '..';
import { serviceOptions } from '../../functions/serviceOption';

export const channelBuyQuery = () =>
  useQuery({
    queryKey: ['channelBuyQuery'],
    queryFn: async () => {
      const response = await GET(GET_CHANNEL_BUYS());
      return serviceOptions('CHANNEL_BUY', response.result.items);
    },
  });

export const mobileBrandQuery = () =>
  useQuery({
    queryKey: ['mobileBrandQuery'],
    queryFn: async () => {
      const response = await GET(GET_MOBILE_BRANDS());
      return serviceOptions('MOBILE_BRAND', response.result.items);
    },
  });

export const breakdownSubQuery = (productType) =>
  useQuery({
    queryKey: ['breakdownSubQuery', productType],
    queryFn: async () => {
      const response = await GET(GET_BREAKDOWN_SUB_OPTIONS(productType));
      return serviceOptions('BREAKDOWN_SUB', response.result.items);
    },
    enabled: !!productType,
  });
